import { createFileRoute } from '@tanstack/react-router';

import { CitationCreate } from '@/module/Author/Citation/CitationCreate';

export const Route = createFileRoute('/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  const { chapterId } = Route.useParams();

  return <CitationCreate publicationId={Number(chapterId)} />;
}
